import { toast as _toast } from 'react-semantic-toasts'

export function toast(cfg) {
  return _toast({
    time: 5000,
    ...cfg
  })
}


// WEBPACK FOOTER //
// ./utilities/toast.js